<script>
import VBtn from 'vuetify/lib/components/VBtn';

/**
 * NOTE:
 * из-за того что цвет кнопки (в основном) не primary, а её темная версия,
 * ... то используем этот компонент чтобы каждый раз явно не прописывать цвет
 * Vuetify версии 2 штатными способами не дает это делать
 */

export default defineComponent({
  extends: VBtn,

  props: {
    color: {
      type: String,
      default: 'electric800 white--text',
    },

    depressed: {
      type: Boolean,
      default: true,
    },

    ripple: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles/_placeholders.scss';

// vuetify class path
// FIXME: use vuetify variables
.v-btn:not(.v-btn--round).v-size {
  &--x-large {
    min-width: 104px;
    min-height: 56px;
    height: auto;
    width: auto;
  }

  &--large {
    min-width: 94px;
    min-height: 48px;
    height: auto;
    width: auto;
  }

  &--small,
  &--x-small {
    min-width: 58px;
    min-height: 24px;
    height: auto;
    width: auto;
  }

  &--default {
    min-width: 160px;
    min-height: 56px;
    height: auto;
    width: auto;
  }
}
</style>
